import React from "react";
import CustomSelect from "@/components/ui/CustomSelect";

// Renders the top of the modal body before the legs list:
//   - Aircraft picker (hidden in append mode)
//   - Trip status toggle (hidden in append mode)
//   - Owner picker (when aircraft has owners; hidden in append mode)
//
// El banner "Copiar del tramo anterior" YA NO vive aquí: se movió DENTRO de
// cada tramo (LegSection) para que sea una decisión per-tramo y entre en el
// scroll-reset al agregar uno nuevo.
function TripHeaderSection({
  isAppendMode,
  availableAircraft,
  selectedAircraft,
  aircraftId,
  onAircraftChange,
  userRole,
  tripStatus,
  setTripStatus,
  aircraftOwners,
  selectedOwner,
  setSelectedOwner,
  loadOwnerPassengers,
  t,
}) {
  return (
    <>
      {/* Aircraft Selection — oculto en append mode (heredado del trip) */}
      {!isAppendMode && (
        <div>
          <label className="text-xs text-slate-400 uppercase tracking-wide mb-2 block">
            {t("newTrip.aircraftRequired")}
          </label>
          <CustomSelect
            value={aircraftId}
            onChange={(e) => onAircraftChange(e.target.value)}
            className="w-full bg-[#0f172a] border border-slate-700 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#0052FF]"
            contentClassName="!duration-0 data-[state=open]:!animate-none data-[state=closed]:!animate-none"
            required
          >
            <option value="">{t("common.selectAircraft")}</option>
            {availableAircraft.map((a) => (
              <option key={a.id} value={a.id}>
                {a.status === "aog"
                  ? `⚠️ ${a.tail_number} - ${a.model} (AOG)`
                  : `${a.tail_number} - ${a.model}`}
              </option>
            ))}
          </CustomSelect>
          {selectedAircraft?.status === "aog" && (
            <div className="mt-2 flex items-start gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-xl">
              <span className="text-red-400 text-base leading-none mt-0.5">⚠️</span>
              <div>
                <p className="text-red-400 text-xs font-semibold">{t("newTrip.aogActiveTitle")}</p>
                <p className="text-slate-400 text-xs mt-0.5">{t("newTrip.aogActiveMessage")}</p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Trip Status — oculto en append mode (heredado).
          Owner es quien decide si el trip va o no (default pending);
          ops_manager coordina y puede ajustarlo. Super_admin retiene
          acceso solo para soporte interno. */}
      {!isAppendMode &&
        (userRole === "owner" || userRole === "ops_manager" || userRole === "super_admin") && (
          <div>
            <label className="text-xs text-slate-400 uppercase tracking-wide mb-2 block">
              {t("newTrip.tripStatus")}
            </label>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => setTripStatus("pending")}
                className={`flex-1 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  tripStatus === "pending"
                    ? "bg-yellow-500/20 text-yellow-400 border border-yellow-500/50"
                    : "bg-slate-800 text-slate-400 border border-slate-700 hover:border-slate-600"
                }`}
              >
                {t("status.pending")}
              </button>
              <button
                type="button"
                onClick={() => setTripStatus("confirmed")}
                className={`flex-1 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  tripStatus === "confirmed"
                    ? "bg-green-500/20 text-green-400 border border-green-500/50"
                    : "bg-slate-800 text-slate-400 border border-slate-700 hover:border-slate-600"
                }`}
              >
                {t("status.confirmed")}
              </button>
            </div>
          </div>
        )}

      {/* Owner Selection (if aircraft has owners) — oculto en append (heredado).
          También oculto para el rol owner: un dueño solo crea viajes para sí
          mismo, así que se auto-asigna (NewTripModal) y el backend fuerza el
          owner_id de la sesión. */}
      {!isAppendMode && userRole !== "owner" && aircraftOwners.length > 0 && (
        <div>
          <label className="text-xs text-slate-400 uppercase tracking-wide mb-2 block">
            {t("newTrip.owner")}
          </label>
          <CustomSelect
            value={selectedOwner}
            onChange={(e) => {
              setSelectedOwner(e.target.value);
              if (e.target.value) loadOwnerPassengers(e.target.value);
            }}
            className="w-full bg-[#0f172a] border border-slate-700 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#0052FF]"
          >
            <option value="">{t("newTrip.selectOwnerHint")}</option>
            {aircraftOwners.map((o) => (
              <option key={o.id} value={o.id}>
                {o.name}
              </option>
            ))}
          </CustomSelect>
        </div>
      )}
    </>
  );
}

export default React.memo(TripHeaderSection);
